module.exports = __webpack_public_path__ + "static/media/main-logo-4.d960c6d9.png";